import tw from 'tailwind-styled-components'

const BaseButton = tw.div`
    inline-flex
    items-center
    select-none
    cursor-pointer
`
export const Link = tw(BaseButton)<{$textClassName?: string}>`
    ${p => p.$textClassName ?? 'text-action-default'}
    hover:text-action-hover
    active:text-action-pressed
`

export const LinkButtonSmall = tw(Link)`
    px-6
    text-12
    h-24
`

type LinkButtonProps = {
  $disabled?: boolean
  $textClassName?: string
  $small?: boolean
  $extraSmall?: boolean
}

export const LinkButton = tw(Link)<LinkButtonProps>`

${({$small, $extraSmall, $disabled, $textClassName}) => `
    ${
      $extraSmall
        ? 'h-auto px-0 text-11'
        : $small
          ? 'h-auto px-12 text-12'
          : 'h-32 px-12 text-14'
    }
    ${$disabled ? 'pointer-events-none text-obscure-old' : ''}
    ${$textClassName ?? 'text-action-default'}
`}

`

export const Button = tw(BaseButton)<{
  $small?: boolean
  $bgClassName?: string
  $textClassName?: string
  $disabled?: boolean
}>`
${({$small, $bgClassName, $textClassName, $disabled}) => `
    hover:bg-action-hover
    active:bg-action-pressed
    ${$small ? 'h-24 px-8 text-12' : 'h-32 px-12 text-14'}
    ${$bgClassName ?? 'bg-action-default'}
    ${$textClassName ?? 'text-on-color'}
    ${$disabled ? 'pointer-events-none bg-obscure text-bg-main-old' : ''}
    rounded-4
`}
`
